// src/utils/parseMentions.js
import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Parses plain text and replaces @mentions with clickable links.
 * Always matches @mentions case-insensitively to handle Pi usernames.
 *
 * @param {string} text - The post content containing @mentions
 * @param {object} mentionMap - Lookup of @mention text to { username, type }
 * @returns JSX elements with clickable links
 */
export function parseMentions(text = '', mentionMap = {}) {
//  console.log('🧠 mentionMap used in parseMentions:', mentionMap);
//  console.log('📝 Original text:', text);

  const mentionRegex = /@[\w._]+/g;
  const parts = [];
  let lastIndex = 0;

  let match;
  while ((match = mentionRegex.exec(text)) !== null) {
    const { index } = match;
    const mention = match[0];
    const lowerKey = mention.toLowerCase();

    // Add any plain text before this mention
    if (index > lastIndex) {
      parts.push(text.slice(lastIndex, index));
    }

    const data = mentionMap[lowerKey];
    if (data) {
      const { username, type } = data;
      const route =
        type === 'store'
          ? `/store/${username}`
          : `/user/${username}`;
  //    console.log(`🔗 Matched mention: ${mention} →`, data);
      parts.push(
        <Link
          to={route}
          className="mention-link"
          key={`mention-${index}`}
        >
          {mention}
        </Link>
      );
    } else {
      console.warn(`❌ No match for mention: ${mention}`);
      parts.push(mention);
    }

    lastIndex = index + mention.length;
  }

  // Add remaining plain text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.map((part, i) =>
    typeof part === 'string' ? <span key={`part-${i}`}>{part}</span> : part
  );
}
